//
// Generated class DocumentExtractionOptions
//

/// <reference path="DocumentExtractionOptions_ManagedObject.ts" />

class DocumentExtractionOptions extends DocumentExtractionOptions_ManagedObject
{

}
